(function (num) {
    function remFn() {
        var c = document.documentElement.clientWidth / num;
        if (c < 76.9) {
            document.documentElement.style.fontSize = c + 'px';
        } else if (c < 76.9) {
            document.documentElement.style.fontSize = '75px';
        } else if (c > 76.9) {
            document.documentElement.style.fontSize = '100%';
        }
        window.addEventListener('resize', remFn, false);
    }
    remFn();
})(10);
























// WEBPACK FOOTER //
// ./src/common/rem.js